import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import axios from 'axios';
import ServiceTable from '../Table/table';
import { makeStyles, TextField, Button } from '@material-ui/core'; // Import TextField and Button
import { CommonConfig } from '../../../../config/common-config';
import ServiceLayout from '../../../invoices/common/serviceLayout';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    buttonBack: {
        background: '#4c4fa6',
        color: '#fff',
        padding: '12px 37px',
        borderRadius: '6px',
        fontFamily: 'Rubik',
        fontWeight: '500 !important',
        margin: '11px 0px 0px 0px',
        fontSize: 'medium',
        cursor: 'pointer',
        border: 'none',
    },
    jumpToPageContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(2),
        justifyContent: 'center',
    },
    inputField: {
        width: '60px',
        marginRight: theme.spacing(1),
    },
}));

const ClosedServiceItec = () => {
    const location = useLocation();
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setClosedService] = useState([]);
    const [page, setPage] = useState(0);
    const [pageInput, setPageInput] = useState(''); // New state for input field
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const roleText = userDetails.result && userDetails.result.data.features[0].roleText;
    const [selectedImc] = useState(location.state.domainname);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);

    const headcells = [
        { id: 'serviceId', label: 'Service ID' },
        { id: 'clientId', label: 'Client ID' },
        { id: 'clientName', label: 'Client name' },
        { id: 'servicetypeId', label: 'Service type', isConcat: 'true', concatElem: ['servicetypeText'] },
        { id: 'serviceYear', label: 'Year' },
        { id: 'startDate', label: 'Start date' },
        { id: 'dateModified', label: 'End date' },
        { id: 'comments', label: 'Remarks' },
        { id: 'statusId', label: 'Status', isConcat: 'true', concatElem: ['statusText'] },
    ];

    const history = useHistory();

    function formatDate(props) {
        return props.map((element) => {
            const tempEndDate = element.dateModified;
            element.dateModified = tempEndDate.split(' ', 1);
        });
    }

    const getCandidates = (currentPage = page) => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/closeservice/${selectedImc}?page=${currentPage}&size=10&sort=dateModified,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                formatDate(response.data.content);
                setClosedService(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch(() => {});
    };

    const getCandidatesItecOthers = (currentPage = page) => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/closeservice/${selectedImc}?page=${currentPage}&size=10&sort=dateModified,desc`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                formatDate(response.data.content);
                setClosedService(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch(() => {});
    };

    useEffect(() => {
        if (selectedImc) {
            if (userTeam === 'ITeC Team') {
                if (roleText === 'ITeCTeam-Others') {
                    getCandidatesItecOthers();
                } else {
                    getCandidates();
                }
            }
        }
    }, [bearerToken, selectedImc, page]);

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const handleClickRow = () => {};

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        if (selectedImc) {
            if (userTeam === 'ITeC Team') {
                if (roleText === 'ITeCTeam-Others') {
                    getCandidatesItecOthers();
                } else {
                    getCandidates();
                }
            }
        }
    };

    const handleSearchQuery = (data) => {
        setSearchQuery(data);
        if (data && data.length > 2) {
            setNoRecordCount(false);
            getSearchValueAdmin(data);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!data) {
            setSearchData([]);
            setPage(0);
            if (selectedImc) {
                if (userTeam === 'ITeC Team') {
                    if (roleText === 'ITeCTeam-Others') {
                        getCandidatesItecOthers();
                    } else {
                        getCandidates();
                    }
                }
            }
        }
    };

    const getSearchValueAdmin = (data) => {
        axios
            .get(
                `${CommonConfig.dev.baseUrl}/api/auth/closeservice/${selectedImc}?search=${data}&page=${page}&size=10&sort=dateModified,desc`,
                {
                    headers: {
                        Authorization: bearerToken,
                    },
                }
            )
            .then((res) => {
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setClosedService([]);
                    }
                    formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {});
    };

    const handlePageInputChange = (e) => {
        setPageInput(e.target.value);
    };

    const handlePageJump = () => {
        const pageNumber = parseInt(pageInput, 10);
        if (!isNaN(pageNumber) && pageNumber >= 0) {
            setPage(pageNumber - 1); // Subtract 1 because pages are zero-indexed in the API
            if (userTeam === 'ITeC Team') {
                if (roleText === 'ITeCTeam-Others') {
                    getCandidatesItecOthers(pageNumber - 1);
                } else {
                    getCandidates(pageNumber - 1);
                }
            }
        }
    };

    const classes = useStyles();
    const excludeColumns = ['comments'];

    const handleBackBtn = () => {
        history.push('/menu/closedservice');
    };

    const filteredRow = searchData && searchData.length ? searchData : rows;

    return (
        <div className={classes.root}>
            <ServiceLayout
                title="Closed Services"
                searchQuery={searchQuery}
                clearField={clearField}
                onChange={handleSearchQuery}
                className={classes}
            >
                {rows && filteredRow.length > 0 ? (
                    <>
                        <ServiceTable
                            headcells={headcells}
                            rows={filteredRow}
                            handleClickRow={handleClickRow}
                            post="admin"
                            service="closed"
                            handleCount={handleCount}
                            pageDetails={pageDetails}
                            loading={loading}
                            prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                            Reports
                        />
                    </>
                ) : (
                    <div className={classes.noRecord}>
                        <h1>No records to display</h1>
                    </div>
                )}
            </ServiceLayout>
            <div className={classes.jumpToPageContainer}>
                <TextField
                    className={classes.inputField}
                    type="number"
                    value={pageInput}
                    onChange={handlePageInputChange}
                    label="Page Number"
                    variant="outlined"
                />
                <Button variant="contained" color="primary" onClick={handlePageJump}>
                    Go
                </Button>
            </div>
            {userTeam === 'ITeC Team' ? (
                <button className={classes.buttonBack} onClick={handleBackBtn}>
                    Back
                </button>
            ) : null}
        </div>
    );
};

export default ClosedServiceItec;
